import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'dateformat'
})
export class DateformatPipe implements PipeTransform {

  constructor(public translate: TranslateService) {
  }

  transform(date: any): any {
    if (date) {
      const lang = this.translate.currentLang;
      const pipe = new DatePipe('en-US');
      switch (lang) {
        case 'es':
          return pipe.transform(date, 'dd-MM-yyyy HH:mm');
        case 'en':
          return pipe.transform(date, 'MM-dd-yyyy HH:mm');
        default:
          return pipe.transform(date, 'dd-MM-yyyy HH:mm');
      }
    }
    return '-';
  }
}
